<template>
  <layout-report-step
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :image="header.image"
    :debug="header.debug"
    :showFooter="false"
    :hasInstructions="true"
    :instructionPictures="instruction.pictures"
    :instructionText="instruction.text"
    :instructionTitle="instruction.title"
    @next="next"
  >
    <v-radio-group v-model="impactType">
      <v-sheet outlined rounded :color="activeCardStyle(payout)" class="mb-2 py-n6">
        <v-card flat @click="impactType = payout">
          <v-list three-line>
            <v-list-item>
              <v-list-item-avatar tile size="60">
                <v-img :src="payoutImage" style="border-radius: 4px" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("report.thgPayoutConfiguration.payout.title") }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <v-icon small>mdi-check</v-icon>
                  {{ $t("report.thgPayoutConfiguration.payout.subtitle1") }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  <v-icon small>mdi-check</v-icon>
                  {{ $t("report.thgPayoutConfiguration.payout.subtitle2") }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-radio :value="payout"></v-radio>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-sheet>
      <v-sheet outlined rounded :color="activeCardStyle(customerAccount)" class="mb-2 py-n6">
        <v-card flat @click="impactType = customerAccount">
          <v-list three-line>
            <v-list-item>
              <v-list-item-avatar tile size="60">
                <v-img :src="customerAccountImage" style="border-radius: 4px" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("report.thgPayoutConfiguration.customerAccount.title") }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <v-icon small>mdi-check</v-icon>
                  {{ $t("report.thgPayoutConfiguration.customerAccount.subtitle1", { company: partnerName }) }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  <v-icon small>mdi-check</v-icon>
                  {{ $t("report.thgPayoutConfiguration.customerAccount.subtitle2") }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-radio :value="customerAccount"></v-radio>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-sheet>
    </v-radio-group>
  </layout-report-step>
</template>

<script lang="ts">
import ThgCheckoutSustainableCard from "@/components/thg/ThgCheckoutSustainableCard.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { Component } from "vue-property-decorator";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { ImpactTypeEnum } from "./enum/impact-type.enum";
import { ReportModule } from "@/store/modules/report.store";
import { GtagModule } from "@/store/modules/gtag.store";

@Component({
  components: {
    LayoutReportStep,
    ThgCheckoutSustainableCard
  }
})
export default class ThgPayoutConfiguration extends ReportStepMixin implements IReportStep {
  screen = ReportScreenEnum.thgPayoutConfiguration;
  isLoading = false;

  payout = ImpactTypeEnum.payout;
  customerAccount = ImpactTypeEnum.customerAccount;

  payoutImage = "https://static.mmmint.ai/wirkaufendeinethg/photo-1580048915913-4f8f5cb481c4-1.jpeg";
  customerAccountImage = "https://static.mmmint.ai/wirkaufendeinethg/customerAccount-1.jpg";

  public header: IReportHeaderData = {
    title: "report.thgPayoutConfiguration.title",
    description: "report.thgPayoutConfiguration.description"
  };

  public instruction: IReportInstructionData = {
    title: "report.thgPayoutConfiguration.instructionTitle",
    text: "report.thgPayoutConfiguration.instructionText",
    pictures: [AssetEnum.charging],
    example: AssetEnum.charging,
    display: true
  };

  get partnerName() {
    return ReportModule.partner.companyName;
  }

  get impactType() {
    return ThgCreateModule.impactType;
  }

  set impactType(type: ImpactTypeEnum) {
    ThgCreateModule.setImpactType(type);
    ThgCreateModule.setImpactFactor(ThgCreateModule.impactTypeItem.baseImpactFactor);
  }

  activeCardStyle(type: ImpactTypeEnum) {
    if (this.impactType === type) {
      return "primary";
    }
    return "";
  }

  next() {
    GtagModule.dispatchBeginCheckoutEvent();
  }

  mounted() {
    ThgCreateModule.setActiveImpactTypeItems([ImpactTypeEnum.payout, ImpactTypeEnum.customerAccount]);
  }

  get color() {
    return getDefaultPartnerColor();
  }

  get isDone() {
    return true;
  }
}
</script>

<style scoped>
.center {
  text-align: center;
}
</style>
